export default __webpack_public_path__ + "static/media/sy-zhjz.67402a60.png";